import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
} from "@chakra-ui/react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const ApplicationInfo = () => {
    const SIDEBAR_WIDTH = "240px";
    const appData = [
        { param: "Betlab Version", value: "4.0" },
        { param: "ViserAdmin Version", value: "5.1.6" },
        { param: "Laravel Version", value: "11.7.0" },
        { param: "TimeZone", value: "UTC" },
    ]

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box p={{ base: 4, md: 8 }} bg="gray.50" minH="100vh" mt="64px" ml={{ base: 0, md: SIDEBAR_WIDTH }}>
                <Flex mb={8} justify="space-between" align="center">
                    <Text fontSize="2xl" fontWeight="semibold" color="#1a202c">Application Information</Text>
                </Flex>

                <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0">
                    <TableContainer>
                        <Table variant="simple">
                            <Thead bg="#4f46e5">
                                <Tr h="50px">
                                    <Th color="white" textTransform="none" borderTopLeftRadius="lg">Parameter</Th>
                                    <Th color="white" textTransform="none" textAlign="right" borderTopRightRadius="lg">Value</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {appData.map((d, i) => (
                                    <Tr key={i} _hover={{ bg: "gray.50" }}>
                                        <Td fontWeight="600" fontSize="sm">{d.param}</Td>
                                        <Td fontSize="sm" textAlign="right">{d.value}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </>
    );
};

export default ApplicationInfo;
